import { Grid } from '@mantine/core';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const SurveyStats = ({ stats, survey }) => {
  if (!stats) {
    return <LazyLoadSpinner />;
  }

  return (
    <Grid>
      <Grid.Col span={6} ta="center">
        <HeaderStatistic title="Opens" stats={stats} stat="opens" id={survey.id} statKey="count" />
      </Grid.Col>
      <Grid.Col span={6} ta="center">
        <HeaderStatistic
          title="Submissions"
          stats={stats}
          stat="submissions"
          id={survey.id}
          statKey="count"
          percentageOfStat="opens"
        />
      </Grid.Col>
    </Grid>
  );
};

export default SurveyStats;
